module.exports = __webpack_public_path__ + "img/pantalla1-1.486152b6.png";